/**
 * Auto-build TOC from H2 headings across all matching scope roots (blog-master & marked sections).
 */
(function () {
  function slugify(text) {
    var s = String(text || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return s || 'abschnitt';
  }

  function fillAutoTocs() {
    document.querySelectorAll('[data-blog-toc-auto="1"]').forEach(function (wrap) {
      var sel =
        wrap.getAttribute('data-blog-toc-scope') ||
        '[data-blog-master-prose], [data-blog-toc-source]';
      var ol = wrap.querySelector('[data-blog-toc-list]');
      if (!ol) return;

      var rootNodes = document.querySelectorAll(sel);
      if (!rootNodes.length) return;

      var rootSeen = new Set();
      var roots = [];
      for (var r = 0; r < rootNodes.length; r++) {
        var node = rootNodes[r];
        if (rootSeen.has(node)) continue;
        rootSeen.add(node);
        roots.push(node);
      }

      var h2Seen = new Set();
      var heads = [];
      for (var i = 0; i < roots.length; i++) {
        var h2list = roots[i].querySelectorAll('h2');
        for (var j = 0; j < h2list.length; j++) {
          var h = h2list[j];
          if (h2Seen.has(h)) continue;
          h2Seen.add(h);
          heads.push(h);
        }
      }

      var min = parseInt(wrap.getAttribute('data-blog-toc-min') || '4', 10);
      if (heads.length < min) return;

      ol.innerHTML = '';
      var used = {};

      heads.forEach(function (h2) {
        var base = slugify(h2.textContent);
        var id = h2.id && h2.id.trim() ? h2.id.trim() : base;
        if (!h2.id) {
          var n = 2;
          while (used[id] || document.getElementById(id)) id = base + '-' + n++;
          used[id] = true;
          h2.id = id;
        } else if (!used[id]) {
          used[id] = true;
        }

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = (h2.textContent || '').trim();
        li.appendChild(a);
        ol.appendChild(li);
      });

      wrap.removeAttribute('hidden');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillAutoTocs);
  else fillAutoTocs();
})();
